import { ImageItem } from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from ".";
import { PaintStyle } from "../../../../domain/drawing";
import {
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IImageObjectStyleConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";

export class ImageObjectStyleReader extends AbstractObjectStyleReader<ImageItem> {
  constructor(private readonly _configuration: IImageObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: ImageItem): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: ImageItem): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  protected readBorderColorConfiguration(source: ImageItem): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: ImageItem): IObjectColorConfiguration {
    return this._configuration.default;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
